export default __webpack_public_path__ + "static/media/image-jeremy.f81223df.png";